<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-action corner">
      <div class="button button-close">
        <button class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </button>
      </div>
    </div>
    <div class="popup-container">
      <div class="popup">
        <div class="popup-title">
          <span class="popup-title-main">過去年度の書籍情報を指定</span>
        </div>
        <div class="popup-content">
          <template v-for="(item, index) in group1.choices_revisions_packages">
            <div :key="'choices_revisions_packages_packages_' + index" class="category">{{ item.name }}</div>
            <ul :key="'choices_revisions_packages_revisions_' + index" class="popup-content-list">
              <li v-for="item2 in item.revisions" :key="'choices_revisions_' + item2.id">
                <a @click.prevent.stop="group1.onRevisionClicked(item.id, item2.id)">{{ item2.name }}</a>
              </li>
            </ul>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'
import * as logicQASearchDetailPastYearBookList from '@/logic/qa/QASearchDetailPastYearBookList'

export default defineComponent({
  props: {
    parentGroup1: {
      type: Object,
      required: true
    }
  },
  setup (props, context) {

    const group1 = logicQASearchDetailPastYearBookList.getGroup(props, context)

    const close = () => {
      context.emit('closeSearchDetailPastYearBookList')
    }

    return {
      group1,
      close
    }
  }
})
</script>

<style lang="scss" scoped>
.popup {
  &-content {
    &-list {
      li {
        border-bottom: 1px solid $color-line;
        padding: 20px 16px;
        color: $color-link;
      }
    }
  }
  &-action {
    width: 95px;
    height: 78px;
    border-top-left-radius: 8px;
    left: auto;
    right: 0;
  }
  .category {
    background-color: $color-bg-paper;
    padding: 32px 20px;
    font-size: 1.4rem;
    color: $color-sup;
  }
}
</style>
